import React from 'react'

const CircleCheck = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.6825 23.1826C36.9994 22.8808 37.4212 22.714 37.8588 22.7173C38.2964 22.7206 38.7156 22.8938 39.028 23.2003C39.3403 23.5069 39.5214 23.9227 39.533 24.3602C39.5445 24.7977 39.3857 25.2225 39.09 25.5451L30.1125 36.7726C29.9581 36.9389 29.7718 37.0723 29.5647 37.1649C29.3576 37.2575 29.1339 37.3074 28.9071 37.3116C28.6802 37.3158 28.4548 37.2743 28.2444 37.1894C28.034 37.1045 27.8429 36.978 27.6825 36.8176L21.729 30.8641C21.5632 30.7096 21.4302 30.5233 21.338 30.3163C21.2457 30.1093 21.1962 29.8858 21.1922 29.6593C21.1882 29.4327 21.2298 29.2076 21.3147 28.9975C21.3996 28.7874 21.5259 28.5965 21.6862 28.4363C21.8464 28.276 22.0373 28.1497 22.2474 28.0648C22.4575 27.9799 22.6826 27.9383 22.9092 27.9423C23.1357 27.9463 23.3592 27.9959 23.5662 28.0881C23.7732 28.1803 23.9595 28.3133 24.114 28.4791L28.8255 33.1883L36.6397 23.2321C36.6538 23.2148 36.6688 23.1982 36.6847 23.1826H36.6825Z"
        fill="white"
        fillOpacity="0.91"
      />
      <circle
        cx="30"
        cy="30"
        r="27.5"
        stroke="white"
        strokeOpacity="0.91"
        strokeWidth="5"
      />
    </svg>
  )
}

export default CircleCheck
